<template>
  <div class="codes" ref="codes">
    <!-- <div class="box is-shadowless"> -->
      <div class="box" ref="filters">
        <filters @filter="onFilter">
          <template #buttons>
            <b-button
              type="is-link"
              :disabled="!selected || checked.length === 0"
              :loading="assigning"
              @click="assign"
              v-if="canManageCodes"
            >Assign Codes</b-button>
          </template>
        </filters>
      </div>
      <div class="columns">
        <div class="column is-8" style="overflow-y: scroll">
          <codes-table
            :height="mainBoxHeight"
            :params="filters"
            :selected.sync="selected"
            :checked.sync="checked"
            ref="codesTable"
          />
        </div>
        <div class="column is-4">
          <code-form
            :height="mainBoxHeight"
            :code="selected"
            :firm-firm-id="filters.firm_firm_id || undefined"
            :type="!selected ? (filters.type || undefined) : undefined"
            @create-success="onCreate"
            @update-success="onUpdate"
            @remove-success="onRemove"
            @close="onClose"
          />
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import CodeForm from "./partials/form";
import CodesTable from "./partials/table";
import Filters from "./partials/filters";
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: [ 'firm' ],
  codeService: CodeService,
  components: {
    CodeForm,
    CodesTable,
    Filters
  },
  data: () => ({
    fullHeight: 0,
    filtersBoxHeight: 0,
    filters: {},
    selected: null,
    checked: [],
    assigning: false
  }),
  computed: {
    mainBoxHeight() {
      const spacesOnTop = 18; // Filters box bot nargin
      return this.fullHeight - this.filtersBoxHeight - spacesOnTop;
    },
    canManageCodes() {
      return this.$store.getters["Auth/hasPermission"]("can manage codes");
    }
  },
  mounted() {
    this.fullHeight = this.$refs.codes.clientHeight;
    this.filtersBoxHeight = this.$refs.filters.clientHeight;
    this.filters.firm_firm_id = this.firm.id
  },
  watch: {
    selected(selected) {
      this.checked = selected.childCodes;
    }
  },
  methods: {
    fetchTableData() {
      return this.$refs.codesTable.fetch();
    },
    async assign() {
      this.assigning = true;

      try {
        const checkedIds = this.checked.map(code => code.id);

        const code = await this.$options.codeService
          .syncChildren(this.selected.id, {
            code_ids: checkedIds,
            includes: "childCodes"
          })
          .then(response => JsonDenormalizer.denormalize(response));

        // Directly modify table data
        this.selected.childCodes = code.childCodes;

        this.$buefy.toast.open({
          message: "Codes has been assigned.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.assigning = false;
    },
    onFilter(filters) {
      this.filters = filters;
      this.$nextTick(async () => {
        // Temporary store current checked codes
        // Checked codes are reset when fetching table data
        const checked = this.checked;
        await this.fetchTableData();
        // Reassign checked codes
        this.checked = checked;
      });
    },
    async onCreate(code) {
      await this.fetchTableData();
      // this.selected = code;
    },
    async onUpdate(code) {
      await this.fetchTableData();
      this.selected = code;
    },
    onRemove() {
      this.fetchTableData();
      this.selected = null;
    },
    onClose() {
      this.selected = null;
    }
  }
};
</script>

<style lang="scss">
.codes {
  height: 88vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Codes/list/index.vue